<template>
  <el-dialog
    title="新增分类"
    :visible.sync="visible"
    width="500px"
    :before-close="handleClose"
  >
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="一级分类" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleComfirm" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: ""
      },
      rules: {
        name: [{ required: true, message: "请输入分类名", trigger: "blur" }]
      },
      loading: false
    };
  },
  methods: {
    addClass() {
      return lib.tmsapi.post({
        api: "api/test/sort/add",
        data: {
          sortName: this.form.name
        }
      });
    },
    handleComfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            await this.addClass();
            this.$emit("success");
            this.handleClose();
          } catch (error) {
            error && this.$message.error(error.msg || error.message);
          }
          this.loading = false
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
    }
  }
};
</script>
<style scoped></style>
